import { Typography, styled } from '@mui/material';

export const GenreTypography = styled(Typography)({
  wordBreak: 'break-word',
  whiteSpace: 'break-spaces',
  textAlign: 'center',
});
